/**
 * The frame every membership-less screen shares: one card centred on a bare
 * page, sized to its own content box rather than to a shell that is not
 * there -- `/comecar`'s two steps and `/`'s no-organisation branch all mount
 * outside the shell and all draw this same frame (Figma `128:426`,
 * `148:1532`, `354:13640`).
 */
import type { ReactNode } from 'react';

import { cn } from '../../../ui/utils';

export function PageRoot(props: { children: ReactNode; className?: string }): ReactNode {
  return (
    <main
      className={cn(
        'mx-auto flex min-h-svh w-full max-w-xl flex-col items-center justify-center px-4 py-12',
        props.className,
      )}
    >
      {props.children}
    </main>
  );
}
